import React, { Component } from 'react'
import { Redirect } from 'react-router-dom'
import _ from 'lodash'
// import axios from 'axios'
// import { API_URL } from '../constants'
import NoAccess from './NoAccess'
// import Login from './Login'
import {
  harmonizeUserName,
  auth,
  setUserProfileLocal,
  getUsersWithCentre
} from '../helpers'
class Auth extends Component {
  state = {}

  async componentWillMount() {
    //check if token
    const { data } = auth() && (await getUsersWithCentre())
    // (await axios.get(`${API_URL}/users`, {
    //   headers: { authorization: auth(true) }
    // }))
    this.setState({ data })
  }

  userExists = (emailToTest, users) => {
    const user = _.find(harmonizeUserName(users), {
      email: emailToTest //harmonizeUserName(emailToTest)
    })
    return user ? user.isActive : false
  }

  userIsAllowed = (idToTest, users, allowedRoles) => {
    return (
      idToTest && allowedRoles.includes(_.find(users, { email: idToTest }).role)
    )
  }

  render() {
    // return <div>{this.props.children}</div>
    const users = this.state.data
    if (!auth()) return <Redirect to="/login" /> //GETTOKEN

    const { app, route, children, roles = ['Level 2', 'Level 3'] } = this.props

    if (!users) return null

    const user = sessionStorage.getItem('user')

    if (!this.userExists(user, users)) return <Redirect to="/login" />

    setUserProfileLocal(user, users)

    const userIsNotAllowed = route ? (
      <NoAccess
        style={{ marginTop: 200 }}
        title="Access denied"
        icon="security"
        subtitle="You do not have sufficient access level to view this page"
      />
    ) : null

    if (!app && !this.userIsAllowed(user, users, roles)) return userIsNotAllowed
    return <div>{children}</div>
  }
}

export default Auth



// WEBPACK FOOTER //
// ./src/core/components/Auth.js